<script setup lang="ts">
defineOptions({
	name: 'UsedForSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-hugeicons:target-02"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('What purposes are cookies used for') }}?
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>{{ $t('In terms of their purpose, cookies can be classified as follows') }}:</p>

			<p>
				{{
					$t(
						'Necessary cookies: These technical cookies allow users to navigate the Platform, enabling basic functions such as navigating between pages and accessing secure areas. They facilitate the management and operation of the Platform. Consent is not required for these cookies, as the Platform or services cannot function properly without them',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Preference cookies: These cookies remember information about your previous browsing sessions, allowing you to access the service with certain features that personalise your experience. For instance, these cookies enable the recognition of the user’s language, help prevent or mitigate attacks against the Platform or its users, ensure the proper playback of multimedia content, and enhance the distribution of web traffic`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Statistical (analytical) cookies: These cookies enable the monitoring and analysis of user behaviour within the Platform. Any information collected through this type of cookie is used to measure activity on any Platform, aiming to implement improvements based on the analysis of data concerning users’ engagement with the service. As a result, we can enhance our pages and the offerings of products or services we provide`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'Marketing cookies: These cookies allow us to understand your browsing habits and display advertisements related to your browsing profile, effectively managing advertising spaces. Their purpose is to show relevant advertisements, tailoring the content to the user',
					)
				}}.
			</p>

			<p>{{ $t('Unclassified cookies: These are cookies that are still in the process of classification') }}.</p>
		</div>
	</section>
</template>
